import chanelTheme from './brands/chanelTheme';
import defaultTheme from './defaultTheme';
import usePageContext from 'hooks/user/usePageContext';

export default function useThemeHandler() {
    const { brandContext } = usePageContext();

    switch (brandContext) {
        case 'chanel':
            return chanelTheme;
        default:
            return defaultTheme;
    }
}
